import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
Vue.use(Router)


const router = new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import( './views/Dashboard.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/Dealers',
          name: 'Repartidores',
          component: () => import('./views/Dealers/index.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/Rutas',
          name: 'Informe Rutas',
          component: () => import('./views/Dealers/Rutas.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/Orders',
          name: 'Ordenes',
          component: () => import('./views/Orders/index.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/Movimientos',
          name: 'Movimientos',
          component: () => import('./views/Orders/Movimientos.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/Compras',
          name: 'Compras',
          component: () => import('./views/Orders/Compras.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/Products',
          name: 'Productos',
          component: () => import('./views/Products/index.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/Restaurants',
          name: 'Restaurantes',
          component: () => import('./views/Restaurants/index.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/User',
          name: 'Usuarios',
          component: () => import('./views/User/index.vue'),
          meta:{requireAuth:true}
        },
        {
          path: '/profile',
          name: 'Perfil de usuario',
          component: () => import('./views/UserProfile'),
          meta:{requireAuth:true}
        },
        {
          path: '/configuration',
          name: 'Configuración',
          component: () => import('./views/Configuration'),
          meta:{requireAuth:true}
        },
        {
          path: '/Auditoria',
          name: 'Auditoria',
          component: () => import('./views/Orders/Auditoria'),
          meta:{requireAuth:true}
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('./views/Login.vue')
        }
      ]
    }
  ]
});

router.beforeEach((to,from,next)=>{
  if (to.matched.some(ruta => ruta.meta.requireAuth)){
    const user = JSON.parse(sessionStorage.getItem("user"))
    if (user){
      next();
    }else {
      next({
        name:'login'
      })
    }
  }else{
    next();
  }
})

export default router;

